function text(value, fallback) {
  return typeof value === 'string' && value.trim() && !/\{\{|\{!!|@[a-z_]+\s*\(/i.test(value)
    ? value : fallback
}

export function normalizeSeoData(input, route, store) {
  const settings = store.getters['settings/settings/settings'] || {}
  const dealer = settings.dealer_title || 'Auto Expert'
  const city = settings.in_city || (settings.city === 'Москва' ? 'Москве' : settings.city) || 'Москве'
  const location = /^в\s/i.test(city) ? city : `в ${city}`
  const path = route.path.toLowerCase().replace(/\/$/, '') || '/'
  const labels = {
    '/': 'Автомобили с пробегом', '/about': 'Об автоцентре', '/contacts': 'Контакты',
    '/credit': 'Автокредит', '/installment': 'Рассрочка', '/trade-in': 'Trade-In',
    '/buyout': 'Выкуп автомобилей', '/banks': 'Банки-партнёры', '/reviews': 'Отзывы',
    '/favorites': 'Избранные автомобили', '/thanks': 'Спасибо за заявку',
    '/privacy': 'Политика конфиденциальности', '/agreement': 'Согласие на рассылку',
    '/cookie': 'Использование cookie',
  }
  const params = route.params || {}
  const fallbackCrumbs = path === '/' ? [] : [{ link: '/', title: 'Главная' }]
  let heading = labels[path]
  if (params.category) {
    heading = params.category === 'new' ? 'Новые автомобили' : 'Автомобили с пробегом'
    fallbackCrumbs.push({ link: `/${params.category}`, title: heading })
    const marks = store.getters['marks/marks/allMarks'] || []
    const mark = marks.find(item => item.slug === params.mark)
    const folders = store.getters['folders/folders/folders'] || []
    const folder = folders.find(item => item.slug === params.model)
    if (params.mark) {
      heading = mark?.title || params.mark
      fallbackCrumbs.push({ link: `/${params.category}/${params.mark}`, title: heading })
    }
    if (params.model) {
      heading += ` ${folder?.title || params.model}`
      fallbackCrumbs.push({ link: `/${params.category}/${params.mark}/${params.model}`, title: folder?.title || params.model })
    }
    if (params.car) {
      const offer = store.getters['catalog/catalog-cars/offer']
      const matches = offer && String(offer.external_id ?? offer.id) === String(params.car)
      heading = matches ? offer.name || heading : heading
      fallbackCrumbs.push({ link: '', title: `Автомобиль №${params.car}` })
    }
  } else {
    heading = heading || (params.bank ? 'Автокредит' : 'Автоцентр')
    if (params.bank) fallbackCrumbs.push({ link: '/credit', title: 'Автокредит' })
    if (path !== '/') fallbackCrumbs.push({ link: '', title: heading })
  }
  const fallbackTitle = `${heading} ${location} — ${dealer}`
  const fallbackDescription = `${heading} в автоцентре «${dealer}» ${location}. Информация об автомобилях и условиях покупки.`
  const data = input || {}
  const crumbs = Array.isArray(data.crumbs) && data.crumbs.every((crumb, index) => (
    crumb && typeof crumb.title === 'string' && crumb.title.trim()
    && typeof crumb.link === 'string' && (crumb.link.trim() || (index === data.crumbs.length - 1 && crumb.link === ''))
  )) ? data.crumbs.map(crumb => ({ ...crumb })) : fallbackCrumbs
  return {
    pageTitle: text(data.page_title, heading),
    title: text(data.title, fallbackTitle),
    description: text(data.description, fallbackDescription),
    crumbs,
  }
}
